import { render, staticRenderFns } from "./KplayLive.vue?vue&type=template&id=c95649b4&scoped=true"
import script from "./KplayLive.vue?vue&type=script&lang=js"
export * from "./KplayLive.vue?vue&type=script&lang=js"
import style0 from "./KplayLive.vue?vue&type=style&index=0&id=c95649b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95649b4",
  null
  
)

export default component.exports